'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';

/**
 * Hook that debounces a value by a specified delay
 * @param value - The value to debounce
 * @param delay - The delay in milliseconds (default: 500)
 * @returns The debounced value
 */
export function useDebouncedValue(value, t0) {
  const $ = _c(4);
  const delay = t0 === undefined ? 500 : t0;
  const [debouncedValue, setDebouncedValue] = useState(value);
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== value) {
    t1 = () => {
      const timeoutId = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => clearTimeout(timeoutId);
    };
    t2 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return debouncedValue;
}